module.exports = __webpack_public_path__ + "html/wave-header_37a049d32df131d08d927b1b48db3cd0.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 153